function pauseSectionVideos(section) {
  section.querySelectorAll("video").forEach((video) => {
    video.pause();
  });
}

function initializeTestimonialVideos(root = document) {
  const sections = root.querySelectorAll("[data-sb-tv]");

  sections.forEach((section) => {
    if (section.dataset.sbTvReady === "true") return;
    section.dataset.sbTvReady = "true";

    section.addEventListener(
      "play",
      (event) => {
        const playing = event.target;
        if (!(playing instanceof HTMLVideoElement)) return;

        section.querySelectorAll("video").forEach((video) => {
          if (video !== playing) video.pause();
        });
      },
      true
    );
  });
}

requestAnimationFrame(() => initializeTestimonialVideos());

document.addEventListener("shopify:section:load", (event) => {
  requestAnimationFrame(() => initializeTestimonialVideos(event.target));
});

document.addEventListener("shopify:section:unload", (event) => {
  const root = event.target;
  if (!root) return;

  if (typeof root.matches === "function" && root.matches("[data-sb-tv]")) {
    pauseSectionVideos(root);
    return;
  }

  root.querySelectorAll?.("[data-sb-tv]").forEach((section) => {
    pauseSectionVideos(section);
  });
});
